var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHosting(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 65,
    viewBox: "0 0 66 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 58C1.66176 57.2099 3.33824 56.4337 5 55.6436C4.89706 47.0911 4.80882 38.5525 4.70588 30C3.13235 30.8317 1.57353 31.6634 0 32.495C0 40.9921 0 49.503 0 58Z",
    fill: "#5DB447"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 22H13V54H18V22Z",
    fill: "#5DB447"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M52 22H47V54H52V22Z",
    fill: "#5DB447"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M65 58C63.1545 56.9128 60.8455 55.793 59 54.7059C59 46.6473 59 38.0586 59 30C60.9909 30.9105 63.0091 32.5895 65 33.5C64.8547 41.7489 65.1453 49.7511 65 58Z",
    fill: "#5DB447"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0.00042916 34L37 12.6087L32.1282 10C21.555 16.3522 10.5732 22.7387 0 29.0909C0 30.7273 0 32.3636 0.00042916 34Z",
    fill: "#5DB447"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M65 34L28 12.1652L31.6027 10L65 28.913V34Z",
    fill: "#5DB447"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M65 62.5484L50.254 54.6774L32.5065 65L13.4541 54.6774L0.0130504 62.8065L0 57.5161L14.7591 49L31.7235 59.7097L50.515 49.6452L65 57V62.5484Z",
    fill: "#5DB447"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M42.9593 19L32.374 26.5484L21.2846 19L17 22.7742L32.878 32L48 21.6559L42.9593 19Z",
    fill: "#5DB447"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M31 26.9368V62L34 59.9926V26L32.5 29.6134L31 26.9368Z",
    fill: "#5DB447"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2884 36.8814L17 29V35.2288L33.779 44L33.1236 43.1102L52 32.0508L49.2472 29L33.1236 37.5169L31.2884 36.8814Z",
    fill: "#5DB447"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0303 54L14 44.0561L14.7727 40H16.3182L32.1591 48.8972L48 40V44.0561L32.0303 54Z",
    fill: "#5DB447"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M23 0H19V4H23V0Z",
    fill: "#5DB447"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M27 4H23V9H27V4Z",
    fill: "#5DB447"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M31 9H26V13H31V9Z",
    fill: "#5DB447"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M37 9H33V14H37V9Z",
    fill: "#5DB447"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M45 0H41V4H45V0Z",
    fill: "#5DB447"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M41 9V4H39H37V9H41Z",
    fill: "#5DB447"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHosting);
export default __webpack_public_path__ + "static/media/hosting.82ea98aabfe6e33a4fa9339b3b206b35.svg";
export { ForwardRef as ReactComponent };